import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3tsmjrbcyw: FaireBrandEntity = {
  token: "b_3tsmjrbcyw",
  type: "brand",
  name: "Arômes & Évasions (Cayves Wholesale)",
  avatarUrl:
    "https://cdn.faire.com/fastly/f3cb5c209ec61867914227804d28dfae1388a31ee3c85e8233e3a4948251b4f3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/516effcbdcc3e2ccac5fb27e3fbb4c100a93e8ce8fbf9ae62809595effbcc350.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f3cb5c209ec61867914227804d28dfae1388a31ee3c85e8233e3a4948251b4f3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/516effcbdcc3e2ccac5fb27e3fbb4c100a93e8ce8fbf9ae62809595effbcc350.png",
  location: "Sorel-Tracy, QC, CAN",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 62,
  isInsider: false,
  description:
    "Welcome to Aromes Evasions, where we believe in enhancing your well-being through the power of your senses. Our shop is dedicated to providing you with a wide range of products that cater to your senses of smell, touch, sight, taste, and hearing. From essential oils and fragrances to soothing herbal teas and natural soaps, we aim to help you create a harmonious and balanced lifestyle.\n\nImmerse yourself in the calming scents of our diffusers and incense, or explore the beauty of our crystals and pendulums. Feel the comfort of our bamboo clothing and experience the tranquility of our soy candles. Whether you're looking for items to enhance your meditation practice or simply seeking a moment of relaxation, Aromes Evasions has something for everyone.\n\nDiscover the enchanting world of wicca and pagan articles, or find the perfect home decor piece to elevate your surroundings. We invite you to open your mind and embrace all that life has to offer. Aromes Evasions is here to accompany you on your journey towards holistic well-being.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:06.828Z",
    importedBy: "entity-db-cli",
  },
};
